/**
 * True when a failed fetch was cancelled (navigation away, AbortController, etc.).
 * Prefers the standard `AbortError` name / DOMException ABORT_ERR code; only falls
 * back to a substring match when no structured signal is available.
 */
export function isAbortedFetchError(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const name = 'name' in error ? String(error.name) : '';

  // DOMException ABORT_ERR === 20; AbortController rejections surface here.
  const code = 'code' in error ? Number(error.code) : NaN;
  if (name === 'AbortError' || (name === 'DOMException' && code === 20)) {
    return true;
  }

  // Some wrappers (ofetch/useFetch) lose the original name but keep an
  // abort-derived cause — inspect it before the textual fallback.
  if (
    'cause' in error &&
    error.cause &&
    error.cause !== error &&
    isAbortedFetchError(error.cause)
  ) {
    return true;
  }

  const message = 'message' in error ? String(error.message) : '';
  const statusMessage =
    'statusMessage' in error ? String(error.statusMessage) : '';

  return `${message} ${statusMessage}`.toLowerCase().includes('abort');
}
